<template>
  <p
    class="balance"
    :class="{ '-loading': loading, '-cantFetch': errors.cantFetchBalance }"
    :style="{ minWidth: minWidth, }"
    ref="balance"
  >
    <template v-if="user.plan && user.plan.prepaid">{{ balance | currency }}</template>
    <template v-if="user.plan && !user.plan.prepaid">Pós pago</template>
  </p>
</template>

<script>
import { mapState } from 'vuex';
import currency from '@/support/filters/currency';

export default {
  name: 'Balance',

  data() {
    return {
      loading: false,
      errors: {
        cantFetchBalance: false,
      },
      lastWidthBalance: 0,
    };
  },

  methods: {
    /**
     * Fetch the balance.
     *
     * @returns {Promise<void>}
     */
    async fetchBalance() {
      try {
        this.loading = true;
        this.resetErrors();

        await this.$store.dispatch('credits/fetchBalance');
      } catch {
        this.errors.cantFetchBalance = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors from component.
     */
    resetErrors() {
      this.errors.cantFetchBalance = false;
    },
  },

  computed: {
    ...mapState('credits', [
      'balance',
    ]),
    ...mapState('auth', [
      'user',
    ]),

    minWidth() {
      if (!this.loading) {
        return '';
      }

      return `${this.lastWidthBalance}px`;
    },
  },

  mounted() {
    this.fetchBalance();

    this.intervalFetchBalance = setInterval(() => {
      if (!this.loading) {
        this.fetchBalance();
      }
    }, 1000 * 60 * 2);

    this.unwatchLoadingToGetLastWidthBalance = this.$watch('loading', () => {
      if (!this.loading) {
        this.lastWidthBalance = this.$refs.balance.clientWidth;
      }
    });
  },

  beforeDestroy() {
    clearInterval(this.intervalFetchBalance);
    this.unwatchLoadingToGetLastWidthBalance();
  },

  filters: {
    currency,
  },
};
</script>

<style lang="scss" scoped>
  .balance {
    &.-loading {
      background-color: #eaeaea;
      display: block;
      height: 10px;
      overflow: hidden;
      position: relative;
      width: 100%;
      font-size: 0px;

      &::before {
        animation: input-loader 0.9s cubic-bezier(0.5, 0, 0, 1.25) infinite;
        background-image: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 0.8),
            rgba(255, 255, 255, 0)
        );
        content: "";
        height: 200%;
        left: -100%;
        position: absolute;
        top: -50%;
        transform: rotate(15deg);
        width: 100%;
      }
    }

    &.-cantFetch {
      @apply text-red-600;
    }
  }
</style>
